export default {"src":"/_next/static/media/bg-left.9cdffe73.svg","height":542,"width":471,"blurWidth":0,"blurHeight":0};